import { AppStateType } from '../reducers'
import { IGroupDetailed } from '../types/group'

export const selectGroup = ({
  group: { description, ...rest },
}: AppStateType): IGroupDetailed => ({
  description: description || '',
  ...rest,
})
